import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const containerVariants = cva("bfrs-mx-auto bfrs-w-full bfrs-px-5 sm:bfrs-px-8", {
  variants: {
    size: {
      sm: "bfrs-max-w-3xl",
      md: "bfrs-max-w-5xl",
      lg: "bfrs-max-w-7xl",
      full: "bfrs-max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});

export type ContainerProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof containerVariants>;

export const Container = forwardRef<HTMLDivElement, ContainerProps>(({ className, size, ...props }, ref) => (
  <div ref={ref} className={cn(containerVariants({ size }), className)} {...props} />
));

Container.displayName = "Container";
